import { render } from "./PoiDetails.vue?vue&type=template&id=490ddfd0&scoped=true"
import script from "./PoiDetails.vue?vue&type=script&lang=js"
export * from "./PoiDetails.vue?vue&type=script&lang=js"

import "./PoiDetails.vue?vue&type=style&index=0&id=490ddfd0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490ddfd0"]])

export default __exports__